import { useUnitSystem } from "@/lib/units";

/**
 * Persistent imperial/metric toggle for spec pages. Reads/writes
 * localStorage after mount so SSR output always matches the imperial
 * default and there is no hydration mismatch.
 */
export function UnitToggle() {
  const [unit, setUnit] = useUnitSystem();

  return (
    <div
      role="group"
      aria-label="Units"
      className="inline-flex items-center rounded-full border border-border bg-card p-0.5 text-xs"
    >
      {(["imperial", "metric"] as const).map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => setUnit(option)}
          aria-pressed={unit === option}
          className={
            unit === option
              ? "px-3 py-1 rounded-full bg-primary text-primary-foreground font-medium capitalize"
              : "px-3 py-1 rounded-full text-muted-foreground hover:text-foreground transition-colors capitalize"
          }
        >
          {option}
        </button>
      ))}
    </div>
  );
}
